
// src/pages/Auth/ForgotPassword.js
import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            // Zde by byl API call pro zaslání resetovacího emailu
            await new Promise(resolve => setTimeout(resolve, 1000)); // Simulace API volání
            setSuccess(true);
        } catch (err) {
            setError('Nepodařilo se odeslat email pro reset hesla. Zkuste to prosím znovu.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-logo">
                        <div className="avatar-circle mx-auto">
                            <i className="fas fa-lock"></i>
                        </div>
                    </div>
                    <h1>Zapomenuté heslo</h1>
                    <p className="text-muted">Zadejte svůj email a my vám zašleme instrukce pro reset hesla</p>
                </div>
                <div className="auth-body">
                    {success ? (
                        <Alert variant="success">
                            <i className="fas fa-check-circle me-2"></i>
                            Instrukce pro reset hesla byly odeslány na vaši emailovou adresu.
                            Zkontrolujte prosím svou emailovou schránku a postupujte podle pokynů.
                        </Alert>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            {error && <Alert variant="danger">{error}</Alert>}

                            <Form.Group className="mb-4">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="vas@email.cz"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <div className="d-grid mb-4">
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                            Odesílání...
                                        </>
                                    ) : 'Odeslat instrukce'}
                                </Button>
                            </div>
                        </Form>
                    )}

                    <div className="text-center mt-3">
                        <Link to="/login" className="text-decoration-none">
                            <i className="fas fa-arrow-left me-2"></i> Zpět na přihlášení
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;